import { FC, ReactNode } from 'react';
import { ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { listNavigationButtonStyles } from './styles';

interface NavigationItemButtonProps {
  icon: ReactNode;
  label: string;
  isDrawerOpen: boolean;
}

const NavigationItemButton: FC<NavigationItemButtonProps> = ({ icon, label, isDrawerOpen }) => (
  <ListItemButton sx={listNavigationButtonStyles}>
    <ListItemIcon sx={{ minWidth: '36px' }}>{icon}</ListItemIcon>
    {isDrawerOpen ? <ListItemText primary={label} /> : null}
  </ListItemButton>
);

export default NavigationItemButton;
